var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53005 5.4133C7.08563 4.99243 6.49682 4.75787 5.88474 4.75787C5.27266 4.75787 4.68385 4.99243 4.23943 5.4133L2.2549 7.29018C1.1174 8.32409 1.93802 10.3005 3.47365 10.2233C4.30646 10.201 4.98287 9.7744 5.88271 9.79065C6.81505 9.7744 7.50771 10.1502 8.34458 10.2233C9.8538 10.2578 10.6338 8.30377 9.51255 7.29018L7.53005 5.4133Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9467 2.65486C10.1707 2.50251 9.57759 3.3658 9.42322 4.10923C8.96009 6.41064 11.1904 6.84939 11.7124 4.61705C11.9257 3.66033 11.5885 2.79705 10.9467 2.65486V2.65486Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65824 3.89797C8.43012 3.89797 9.05777 3.02047 9.05777 1.94391C8.98059 -0.647969 6.3359 -0.647969 6.26074 1.94391C6.26074 3.02047 6.8884 3.89797 7.65824 3.89797V3.89797Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34647 4.10923C2.19412 3.36579 1.59897 2.50251 0.82303 2.65486C-0.615095 3.01845 -0.00571993 6.08361 1.39991 6.09173C2.19616 6.06533 2.56381 5.14111 2.34647 4.10923V4.10923Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11145 3.89797C4.88129 3.89797 5.50895 3.02047 5.50895 1.94391C5.43379 -0.647969 2.7891 -0.647969 2.71191 1.94391C2.71191 3.02047 3.33957 3.89797 4.11145 3.89797V3.89797Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPets);
export default __webpack_public_path__ + "static/media/Pets.b51d5769bd7afb1cd4ceda976e89f406.svg";
export { ForwardRef as ReactComponent };